import {NgModule} from '@angular/core';

import {ImageHeaderComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {PrismLogoModule} from "../../../../shared/components/prism-logo/prism-logo.module";

/**
 * Module for the ImageHeaderModule
 * @class
 */
@NgModule({
  declarations: [ImageHeaderComponent],
  exports: [ImageHeaderComponent],
  imports: [PrismLogoModule,
    IonicModule],
  providers: [],
})
export class ImageHeaderModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-header/image-header.module.ts